import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { ProcessOption } from 'data/processOption/processOption.types';

export enum ProcessMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newProcessOptions: ProcessOption = {
  id: '',
  PROCNAME: '',
  PARAMNAME: '',
  PARAMVALUE: '',
  COMMENTS: '',
};

export const processColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('processOptions.grid.processName'),
    field: 'PROCNAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'procName',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('processOptions.grid.parameterName'),
    field: 'PARAMNAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramName',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('processOptions.grid.parameterValue'),
    field: 'PARAMVALUE',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'paramValue',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('processOptions.grid.comment'),
    field: 'COMMENTS',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'comments',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
];
